import React from 'react';

const DocumentationTab = () => {
  return (
    <div>
      <h2>Documentation</h2>
      {/* Add documentation content */}
    </div>
  );
};

export default DocumentationTab; 